module.exports = __webpack_public_path__ + "static/montserrat-v12-latin-500-f0f2716c5fe401d175b88715e7d28685.woff2";